import { render, staticRenderFns } from "./navScreen.vue?vue&type=template&id=1980f7ad&scoped=true"
import script from "./navScreen.vue?vue&type=script&lang=js"
export * from "./navScreen.vue?vue&type=script&lang=js"
import style0 from "./navScreen.vue?vue&type=style&index=0&id=1980f7ad&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1980f7ad",
  null
  
)

export default component.exports